import ErrorComponent from "@/components/atoms/ErrorComponent";
import CompanyHeader from "@/components/molecules/card-headers/companies/CompanyHeader";
import CompanyEditCard from "@/components/molecules/cards/companies/CompanyEditCard";
import { UUID_REGEX } from "@/constants/regexs";
import { FC } from "react";
import { useParams } from "react-router-dom";

const CompanyEditView: FC = () => {
  const { id } = useParams<{ id: string }>();

  if (!id || !UUID_REGEX.test(id)) {
    return (
      <ErrorComponent error={{ status: 404, data: {} }} absolute returnButton />
    );
  }

  return (
    <div className="formalys-page formalys-detail-page formalys-edit-page">
      <CompanyHeader id={id} isEdit />
      <CompanyEditCard id={id} />
    </div>
  );
};

export default CompanyEditView;
